import { URL_LANGUAGE } from "../../constants/inital-lang.c";
import { LANGUAGES } from "../../constants/languages.c";

// Returns the url prefix for the current language e.g. "/jp" or "/cn". Empty string for english
export const getLanguagePrefix = () => {
  return URL_LANGUAGE === LANGUAGES.EN ? "" : `/${URL_LANGUAGE}`;
};
